/**
 * Created by Jason on 2017-5-24.
 */

import main from './main'
import util from './util'
//上传中
import fullLoading from  '../lib/full-loading/full-loading'
import '../lib/full-loading/full-loading.css'
//编辑器
import Editor from '../../assets/js/editor';


//二维码
import '../lib/jquery-qrcode/jquery-qrcode'


//下载
import download from './download'
import '../css/download.css'

//文件上传框
import '../lib/upload-box/index.css';
import UploadBox from '../lib/upload-box';


/**
 * 主题详情
 */
class TopicDetail {
    constructor(el, userData, productDataName, isReply = true) {
        let ts = this;
        ts.$el = $(el).eq(0);
        ts.userData = userData;
        ts.isReply = isReply;
        ts.productDataName = productDataName;
        ts._renderDom();
        ts._toUp();
        ts._topicEvent();
        download.addListener(ts.$el);
    }

    /**
     * 初始渲染
     * @private
     */
    _renderDom() {
        let ts = this;
        let $el = ts.$el;
        $el.addClass('topic-box');
        if (ts.isReply) {
            $el.css('paddingBottom', 100);
        }
        $el.html(
            `  <div class="topic-content">
            <div class="topic-scroll" id="topic-scroll">
                <div class="topic-detail">
                </div>
                <div class="topic-reply-list"><div class="empty">正在加载数据...</div></div>
            </div>
            <a href="javascript:;" class="fa fa-caret-up to-topic-top">TOP</a>
        </div>`
        )
        ts.$topicScroll = $el.find('.topic-scroll')
        ts.$topicDetail = $el.find('.topic-detail').eq(0);
        ts.$topicReplyList = $el.find('.topic-reply-list')
        ts.TopicTeplyListData = [];

        if (ts.isReply) {
            ts._initReply();
        }
    }

    /**
     * 主题按钮事件
     */
    _topicEvent() {
        let ts = this
        let isSubmit = false
        //刷新
        ts.$topicDetail.on('click', '.topic-refresh', (e) => {
            if (!ts.topicId) {
                return;
            }
            if (isSubmit) {
                return;
            }
            ts.getTopic(ts.topicId);
        });
        /**
         * web版二维码
         */
        ts.$topicDetail.on('mouseover', '.wechat-web-btn', (e) => {
            let $t = $(e.target)
            let id = $t.data('id') - 0
            if (!id) {
                return
            }
            $t.find('.qr-code').eq(0).qrcode({
                // render method: 'canvas', 'image' or 'div'
                render: 'canvas',
                minVersion: 1,
                maxVersion: 40,
                ecLevel: 'L',
                left: 0,
                top: 0,
                size: 160,
                fill: '#000',
                background: null,
                text: 'http://m.custom.orancrab.com/topic.html?id=' + id,
                radius: 0,
                quiet: 0,
                mode: 0,
                mSize: 0.1,
                mPosX: 0.5,
                mPosY: 0.5,
                label: '',
                fontname: 'sans',
                fontcolor: '#ec6a03',
                image: null
            })
            $t.data('id', 0)
        })
        /**
         * 小程序二维码
         */
        ts.$topicDetail.on('mouseover', '.wechat-app-btn', (e) => {
            let $t = $(e.target)
            let id = $t.data('id') - 0
            if (!id) {
                return
            }
            let $qrCode = $t.find('.qr-code').eq(0);
            $qrCode.html('正在生成二维码，请稍侯...');
            let $img = $(new Image());
            $img.on('load', () => {
                $qrCode.html($img);
                //修复IE11自动加宽高
                setTimeout(() => {
                    $img.attr('height', 'auto');
                });
            });
            $img.on('error', () => {
                $qrCode.html('生成失败，系统错误。');
            });
            $img.attr('src', SERVER + '/wechat/getWXAQRCode?path=' + encodeURIComponent('pages/topic/topic?topicId=' + id) + '&width=200');
            $t.data('id', 0);
        })
    }

    /**
     * 获取主题
     * @param topicId
     * @param callback
     */
    getTopic(topicId, callback) {
        let ts = this;
        if (!topicId) {
            callback && callback(false)
            return
        }
        if ( ts.topicId !== topicId) {
            //需要暂停语音和播放
            download.stopAudio();
        }
        ts.topicId = topicId;
        ts.getTopicDetail((result) => {
            if (!result) {
                callback && callback(false);
                return;
            }
            $.get(SERVER + '/reply/getReplyList', {
                'topicId': ts.topicId,
                'pageSize': 1000
            }, (json) => {
                if (json.status == 0) {
                    ts.TopicTeplyListData = json.data.content
                    ts._renderReplyList(json.data)
                    callback && callback(true);
                } else {
                    callback && callback(false);
                }
            })
        })
    }

    /**
     * 获取主题详情
     * @returns {*}
     */
    getTopicDetail(cb) {
        let ts = this
        if (!ts.topicId) {
            cb(false);
            return
        }
        return $.get(SERVER + '/topic/topicDetail', {
            'topicId': ts.topicId
        }, (json) => {
            if (json.status == 0) {
                ts.topicDetail = json.data
                if (cb) {
                    cb(true)
                }
                ts._renderTopic(json.data);

            } else {
                cb(false);
                ts.topicDetail = null
            }
        })
    }
    
    /**
     * 渲染主题
     * @param topic
     */
    _renderTopic(topic) {
        let ts = this;
        let addUserInfo = topic.addUserInfo

        let html = `
        <div class="topic-menu">
            <div class="user-box">
                <img src="${addUserInfo.headImg ? SERVER + '/upload/image/' + addUserInfo.headImg : '/img/default-head.png'}">
                <span class="user-name">${addUserInfo.name + '（' +
        (addUserInfo.title ? addUserInfo.title : (util.getIdentityName(addUserInfo) || '我方公司') ) + '）'}</span>
                <span class="time">${util.getTimeStr(topic.addTime)}</span>
            </div>
            
            <a href="javascript:;" class="btn btn-sm btn-default fa fa-qrcode wechat-btn wechat-web-btn" 
            data-id="${topic.topicId}"> 
            微信网页<span class="qr-code"></span></a>
            <a href="javascript:;" class="btn btn-sm btn-default fa fa-qrcode wechat-btn wechat-app-btn" data-id="${topic.topicId}"> 微信小程序<span class="qr-code"></span></a>
            <a href="javascript:;" class="btn btn-sm btn-default fa fa-refresh topic-refresh"> 刷新</a></a>
        `
        
        ts.topicTypeId = topic.topicTypeId;
        
        html += `</div>
            <div class="topic-type">${ts._getTaskName(topic.productTaskId)}</div>
            <h1>${topic.title}</h1>
            <div class="content">${topic.content}</div>`
        if (topic.attachmentFiles && topic.attachmentFiles.length) {
            html += download.renderList(topic.attachmentFiles, 'topic', topic.topicId);
        }
        ts.$topicDetail.html(html);
    }
    _getTaskName (productTaskId) {
        let names = this.productDataName[productTaskId];
        return names.productName + '/' + names.taskName;
    }
    /**
     * 渲染回复列表
     * @private
     */
    _renderReplyList(data) {
        let ts = this
        if (!data.content || !data.content.length) {
            ts.$topicReplyList.html('<div class="empty">没有回复</div>')
            return
        }
        let html = ``
        data.content.forEach((detail) => {
            html += ts._renderReply(detail)
        })
        ts.$topicReplyList.html(html);
    }

    /**
     * 渲染单个回复
     * @param detail
     */
    _renderReply(detail) {
        let addUserInfo = detail.addUserInfo
        let html = '<div><div class="reply-menu">'
        html += `</div>
                <div class="user-box">
                <img src="${addUserInfo.headImg ? SERVER + '/upload/image/' + addUserInfo.headImg : '/img/default-head.png'}">
                <span class="user-name">
                ${addUserInfo.name + '（' +
        (addUserInfo.title ? addUserInfo.title : (util.getIdentityName(addUserInfo) || '客户') ) + '）'}
                </span>
                <span class="time">${util.getTimeStr(detail.replyTime)}</span>
            </div>
            <div class="content">${detail.content}</div>`
        if (detail.attachmentFiles && detail.attachmentFiles.length) {
            html += download.renderList(detail.attachmentFiles);
        }
        html += `</div>`
        return html
    }
    
    /**
     * 初始化回复
     * @private
     */
    _initReply() {
        let ts = this
        let $el = ts.$el;
        let userType = ts.userData.company.userType - 0;
        let html = `<div class="reply-box"><div class="reply-edit" contenteditable="true" placeholder="请输入回复内容，5-5000字。"></div>
                <div class="reply-bar">
                    <label class="btn btn-default add-files fa fa-paperclip"> 附件(0)</label>`;
        if (userType === 2) {
            html += '<label class="reply-tips"><input class="notify-admin" type="checkbox">' +
                ' 附带提醒公司负责人（需要上传附件才有提醒）</label>';
        }
        
        html += `<div class="buttons">
                        <button class="btn btn-danger abandon" type="button">放弃</button>
                        <button class="btn btn-success submit" type="button">回复</button>
                    </div>
                </div>
                </div>`;
        $el.append(html);
        
        let $replyBox = ts.$replyBox = $el.find('.reply-box')
        let $replyEdit = ts.$replyEdit = $replyBox.find('.reply-edit')
        let $replyFileButton = $replyBox.find('.add-files')
        let $replyTips = $replyBox.find('.reply-tips');
        let $notifyAdmin = $replyBox.find('.notify-admin');
        new Editor($replyEdit);
        //获取焦点，展开
        $replyEdit.on('focus', function () {
            $el.animate({paddingBottom: 400})
            $replyBox.animate({height: 400})
            ts.replyShow = true;
            isShowNotify();
        })
        //取消
        $replyBox.find('.abandon').on('click', function () {
            //取消回复
            ts.smallReply(true)
        });
        //上传文件框处理
        let uploadFiles = [];
        
        //上传框
        let uploadBox = ts.replyUploadBox = new UploadBox({
            confirm:(remotes, uploads)=>{
                uploadFiles = uploads;
                $replyFileButton.html(' 附件(' + (uploads.length) + ')')
                isShowNotify();
            },
            cancel: () => {
                uploadFiles = [];
                $replyFileButton.html(' 附件')
                isShowNotify();
            },
            maxAllNumber:10,
            maxAllSize: 100 * 1000 * 1000,
            el: $replyFileButton,
            key: 'reply'
        });
        
        $replyFileButton.on('click', () => {
            uploadBox.show({
                uploadFiles: uploadFiles,
            });
        })
        
        
        //是否显示提醒内容
        function isShowNotify () {
            if (uploadFiles.length && userType === 2 && ts.topicTypeId == 4) {
                $replyTips.show();
                return true;
            } else {
                $replyTips.hide();
                return false;
            }
        }
        
        //提交
        let isSubmit = false
        $replyBox.find('.submit').on('click', (e) => {
            if (!ts.topicId) {
                return
            }
            if (isSubmit) {
                return
            }
            let content = $replyEdit.trumbowyg('html')
            let contentFilter = util.htmlLength(content)
            if (contentFilter < 5) {
                util.error('回复内容至少输入5个字')
                return false
            }
            if (contentFilter > 5000) {
                util.error('回复内容不能超过5000字')
                return false
            }

            let formData = new FormData()
            formData.append('content', content)
            formData.append('topicId', ts.topicId);
            uploadFiles.forEach((file) => {
                formData.append('replyFiles[]', file)
            })
            
            if (isShowNotify() && $notifyAdmin.prop('checked')) {
                formData.append('notifyAdmin', 1);
            }
            
            isSubmit = true
            fullLoading.show()
            $.ajax({
                type: 'POST',
                url: SERVER + '/reply/addReply',
                data: formData,
                processData: false,
                contentType: false,
                success(json) {
                    if (json.status == 0) {
                        //回复成功
                        ts.smallReply()
                        util.success('回复成功');
                        uploadBox.cancel();
                        if (!ts.TopicTeplyListData || !ts.TopicTeplyListData.length) {
                            ts.TopicTeplyListData = [json.data]
                            ts.$topicReplyList.html(ts._renderReply(json.data))
                        } else {
                            ts.$topicReplyList.append(ts._renderReply(json.data))
                            ts.$topicScroll.scrollTop(ts.$topicScroll[0].scrollHeight)
                        }
                    }
                },
                complete() {
                    isSubmit = false
                    fullLoading.hide()
                }
            })
        })
    }
    /**
     * 最小化输入框
     * @param isConfirm
     */
    smallReply(isConfirm) {
        let ts = this
        if (!ts.replyShow) {
            if (typeof isConfirm === 'function') {
                isConfirm()
            }
            return
        }
        let content = ts.$replyEdit.trumbowyg('html')
        if (isConfirm &&
            (content)) {
            util.confirm('是否放弃当前编辑内容？', () => {
                ts.emptyReply(content)
                if (typeof isConfirm === 'function') {
                    isConfirm()
                }
            })
            return
        }
        ts.emptyReply(content)
        if (typeof isConfirm === 'function') {
            isConfirm()
        }
    }

    /**
     * 清空回复内容
     * @param content
     */
    emptyReply(content) {
        let ts = this
        ts.$el.animate({paddingBottom: 100})
        ts.$replyBox.animate({height: 100})
        ts.replyUploadBox.cancel();
        if (content) {
            ts.$replyEdit.trumbowyg('empty');
        }
        //是否已经显示
        ts.replyShow = false
    }

    /**
     * 回到顶部
     */
    _toUp() {
        let ts = this
        let $topicScroll = ts.$topicScroll
        let $toTopicTop = ts.$el.find('.to-topic-top')
        $topicScroll.on('scroll', (e) => {
            if ($topicScroll.scrollTop() > 200) {
                $toTopicTop.stop().fadeIn(200)
            } else {
                $toTopicTop.stop().fadeOut(200)
            }
        })
        $toTopicTop.on('click', () => {
            $topicScroll.animate({
                'scrollTop': 0
            })
        })
    }
}
module.exports = TopicDetail;


// WEBPACK FOOTER //
// ./src/assets/js/topic-detail.js